import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import {
	catchError,
	switchMap,
	tap,
} from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';

import { BaseComponent } from '@rs-bank/rs-core';
import { CustomFormGroup as CustomFormGroupNew } from '@rs-bank/rs-forms-extention';
import { ComponentBox } from '@rs-bank/rs-layout';
import { detectChanges } from '@rs-bank/rs-rxjs-extention';

import { ApplicationErrors } from 'ib/internetbank-core/ib-exceptions/ib-exceptions';

import {
	InternetbankAppApplicationException,
	MiddleValidationException,
	OperationConfirmationRequiredException,
	OperationConfirmationRequiredValidationException,
} from '../../../common/exceptions/exceptions';
import { ConstantsService, InternetBankSettings } from '../../../common/services/constants.service';
import { OperationConfirmation } from '../../../shared/confirmation/core/models/operation-confirmation.model';
import { FieldOptions } from '../../../ui/controls/field.model';
import { PdfIframeControlComponent } from '../../../ui/controls/pdf-iframe-control/pdf-iframe-control.component';
import { DeprecatedPopUpService } from '../../../ui/controls/pop-up/pop-up.service';
import { CustomFormControl } from '../../../ui/custom-reactive-forms/custom-form-control';
import { CustomFormGroup } from '../../../ui/custom-reactive-forms/custom-form-group';
import { OtpConfirmation } from '../../authorization.model';
import { ResetPasswordComponent } from '../../login/reset-password/reset-password.component';
import { BiometricsRegistrationErrorPopUpComponent } from '../biometrics-registration-error-pop-up/biometrics-registration-error.pop-up.component';
import { BiometricsCreateClientConfirmResponse, BiometricsRegistrationWizardService } from '../biometrics-registration-wizard/biometrics-registration-wizard.service';
import { RegistrationProductConfirmationCodeComponent } from '../components/registration-product-confirmation-code/registration-product-confirmation-code.component';


@Component({
	selector: 'app-biometrics-registration-offer-statement-pop-up',
	templateUrl: './biometrics-registration-offer-statement.pop-up.component.html',
	styleUrls: ['./biometrics-registration-offer-statement.pop-up.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [BiometricsRegistrationWizardService],
	standalone: false,
})
export class BiometricsRegistrationOfferStatementPopUpComponent extends BaseComponent implements OnInit {

	@Input()
	public resetPasswordPopUpComponent: ResetPasswordComponent;

	@Input()
	public biometricsRegistrationErrorPopUpComponent: BiometricsRegistrationErrorPopUpComponent;

	@Output()
	public closeWindow: EventEmitter<boolean> = new EventEmitter();

	public readonly popUpId = 'biometrics-registration-offer-statement-pop-up-id';

	public pdfIframeControlComponentBox = new ComponentBox(
		PdfIframeControlComponent,
		(componentInstance: PdfIframeControlComponent) => {
			componentInstance.customFormControl = new CustomFormControl(new FieldOptions({
				'@type': 'pdf-iframe-control',
				name: 'pdfIframeControl',
				required: true,
				height: '50%',
				sidebarVisible: false,
			}));
		},
		{ cssClassList: ['popup-biometrics-registration-offer-statement__pdf'] },
	);
	public registrationProductConfirmationCodeComponentBox = new ComponentBox(
		RegistrationProductConfirmationCodeComponent,
		(componentInstance: RegistrationProductConfirmationCodeComponent) => {


			componentInstance.confirmationCode.pipe(
				tap((data: string) => {
					data = data?.trim();
					this.confirmation.otpValue = data;
					this.newForm.patchValue({ confirmationCode: data });
				}),
			)
				.subscribe();

			componentInstance.resetTimer
				.pipe(
					tap(() => {
						this.makeCreateClientCreate()
							.pipe(
								// eslint-disable-next-line @typescript-eslint/no-explicit-any
								catchError((error: any) => {
									componentInstance.confirmationCodeControl.setValue(null);
									return this.cathError(error);
								}),
							)
							.subscribe();
					}),
				)
				.subscribe();
		});

	public resetFormStep1: CustomFormGroup;
	public settings: InternetBankSettings = ConstantsService.SETTINGS;
	public resetActivated: boolean = false;

	public errors: ApplicationErrors | null;
	public confirmation: OperationConfirmation = new OperationConfirmation();
	public newForm = new CustomFormGroupNew({
		confirmationCode: new UntypedFormControl(null, [
			Validators.required,
			Validators.maxLength(4),
			Validators.minLength(4),
		]),
	});

	constructor(
		private modalService: DeprecatedPopUpService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		public override  changeDetectorRef: ChangeDetectorRef,
		public biometricsRegistrationWizardService: BiometricsRegistrationWizardService,
	) {
		super(changeDetectorRef);
	}


	public openModal(id: string): void {
		this.modalService.open(id);
	}

	public closeModal(id: string): void {
		this.closeWindow.emit(false);
		this.modalService.close(id);
	}

	public load(): Observable<OtpConfirmation | InternetbankAppApplicationException> {
		return this.biometricsRegistrationWizardService.loadOfferDocument()
			.pipe(
				tap((data: Blob) => {
					this.updateLayoutPdf(data);
				}),
				switchMap(() => this.makeCreateClientCreate()),
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				catchError((error: any) => this.cathError(error)),
			);
	}

	public ngOnInit(): void {

	}

	public showPopUp(): void {
		this.closeWindow.emit(true);

		this.load()
			.pipe(
				tap(() => {
					this.resetPopUpState();
					this.openModal(this.popUpId);

					this.changeDetectorRef.markForCheck();

				}))
			.subscribe();
	}

	public close(): void {
		this.closeModal(this.popUpId);
	}

	public next1(): void {
		this.biometricsRegistrationWizardService.createClientConfirm(this.confirmation)
			.pipe(
				tap((data: BiometricsCreateClientConfirmResponse) => {
					this.close();
					this.resetPasswordPopUpComponent.showPasswordResetFormForBiometrics(data);
				}),
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				catchError((error: any) => this.cathError(error)),
				detectChanges(this),
			)
			.subscribe();
	}


	private makeCreateClientCreate(): Observable<OtpConfirmation> {
		return this.biometricsRegistrationWizardService.createClietntCreate();
	}

	private updateLayoutPdf(pdfData: Blob): void {
		const pdfControl = this.pdfIframeControlComponentBox;
		pdfControl.componentInstance$
			.pipe(
				tap((value: PdfIframeControlComponent | undefined) => {
					value?.customFormControl.setValue(pdfData);
					value?.changeDetectorRef.detectChanges();
				}),
			)
			.subscribe();
	}

	private resetPopUpState() {
		this.resetErrors();
	}

	private resetErrors() {
		this.errors = null;
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	private cathError(error: any): Observable<InternetbankAppApplicationException> {

		switch (true) {
			case error instanceof OperationConfirmationRequiredException:
				this.confirmation.operationId = error.operationConfirmationRequired.operationId;
				break;
			case error instanceof OperationConfirmationRequiredValidationException:
				error = new MiddleValidationException(error.errors);
				break;
			case error instanceof InternetbankAppApplicationException:
			default:
				this.close();
				this.biometricsRegistrationErrorPopUpComponent.exception = error;
				this.biometricsRegistrationErrorPopUpComponent.showPopUp();
				break;
		}

		this.errors = error?.errors;

		return throwError(() => error);

	}
}
